if ( jQuery(".swiper-soundcloud").length ) {
    let SwiperSoundcloud = new Swiper('.swiper-soundcloud', {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        spaceBetween: 30,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 0,
            slideShadows: false,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 100,
                    depth: 500,
                    modifier: 1,
                    slideShadows: false,
                },
            }
          }
    });
}